import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  MODULE_PATH,
  OWNERS_INDEX,
  ZONES,
  ZONES_SHOW,
  BILLING,
  BILLING_ACCOUNTING,
  BRANCH_LIST,
  RATE,
} from "./routesInterface";

export default [
  {
    path: MODULE_PATH,
    name: "Owners",
    meta: { requiresAuth: true },
    redirect: { name: "OwnersHome" },
    component: () => import("@/modules/Owners/Owners"),
    children: [
      // DASHBOARD
      {
        path: "home",
        name: "OwnersHome",
        component: () => import("@/modules/Owners/Pages/Index"),
        meta: {
          code: MODULE.OWNERS.DASHBOARD,
        },
      },
      // OWNERS
      {
        path: "list",
        name: "Owner List",
        component: () => import("@/modules/Owners/Pages/Owners/OwnerList"),
        meta: {
          code: MODULE.OWNERS.OWNERS,
        },
      },
      {
        path: "detail/:ownerId?",
        name: "Owner Details",
        component: () =>
          import("@/modules/Owners/Pages/Owners/Detail/OwnerDetailWrapper.vue"),
        meta: {
          code: MODULE.OWNERS.OWNERS,
        },
        children: [
          {
            path: "information",
            name: "Owner Details Information",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailInformation.vue"
              ),
            meta: {
              code: MODULE.OWNERS.OWNERS,
            },
          },
          {
            path: "pricing",
            name: "Owner Details Pricing",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailPricing.vue"
              ),
            meta: {
              code: MODULE.OWNERS.OWNERS,
            },
          },
          {
            path: "personalization",
            name: "Owner Details Personalization",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailPersonalization.vue"
              ),
            meta: {
              code: MODULE.OWNERS.OWNERS,
            },
          },
          {
            path: "contracts",
            name: "Owner Details Contracts",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailContracts.vue"
              ),
            meta: {
              code: MODULE.OWNERS.OWNERS,
            },
          },
          {
            path: "hierarchy",
            name: "Owner Detail Hierarchy",
            component: () =>
              import(
                "@/modules/Owners/Pages/Owners/Detail/OwnerDetailHierarchy"
              ),
            meta: {
              breadcrumb: [],
              code: MODULE.OWNERS.OWNERS,
            },
          },
        ],
      },
      // BRANCHES
      {
        path: "branch/list",
        name: "Branch list",
        component: () => import("@/modules/Owners/Pages/Branch/BranchList"),
        meta: {
          breadcrumb: [{ name: "common.owners", link: BRANCH_LIST }],
          code: MODULE.OWNERS.BRANCHES,
        },
      },
      {
        path: "branch/form",
        name: "Branch Form",
        component: () => import("@/modules/Owners/Pages/Branch/BranchForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.BRANCHES,
        },
      },
      {
        path: "branch/detail/:id",
        name: "Branch Detail",
        component: () =>
          import("@/modules/Owners/Pages/Branch/Detail/BranchDetailWrapper"),
        meta: {
          breadcrumb: [{ name: "common.branches", link: BRANCH_LIST }],
          code: MODULE.OWNERS.BRANCHES,
        },
        children: [
          {
            path: "information",
            name: "Branch Information",
            component: () =>
              import(
                "@/modules/Owners/Pages/Branch/Detail/BranchDetailInformation.vue"
              ),
            meta: {
              breadcrumb: [],
              code: MODULE.OWNERS.BRANCHES,
            },
          },
          {
            path: "fleet",
            name: "Branch Fleet",
            component: () =>
              import(
                "@/modules/Owners/Pages/Branch/Detail/BranchDetailFleet.vue"
              ),
            meta: {
              breadcrumb: [],
              code: MODULE.OWNERS.BRANCHES,
            },
          },
        ],
      },
      // PARKINGS
      {
        path: "parking/list",
        name: "Parking List",
        component: () => import("@/modules/Owners/Pages/Parking/ParkingList"),
        meta: {
          code: MODULE.OWNERS.PARKINGS,
        },
      },
      {
        path: "parking/form",
        name: "Parking Form",
        component: () => import("@/modules/Owners/Pages/Parking/ParkingForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.PARKINGS,
        },
      },
      {
        path: "parking/detail/:id",
        name: "Parquing Detail",
        component: () =>
          import("@/modules/Owners/Pages/Parking/Detail/ParkingDetailWrapper"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.PARKINGS,
        },
        children: [
          {
            path: "information",
            name: "Parking Information",
            component: () =>
              import(
                "@/modules/Owners/Pages/Parking/Detail/ParkingDetailInformation"
              ),
            meta: {
              breadcrumb: [],
              code: MODULE.OWNERS.PARKINGS,
            },
          },
          {
            path: "fleet",
            name: "Parking Fleet",
            component: () =>
              import(
                "@/modules/Owners/Pages/Parking/Detail/ParkingDetailFleet"
              ),
            meta: {
              breadcrumb: [],
              code: MODULE.OWNERS.PARKINGS,
            },
          },
        ],
      },
      // ZONES
      {
        path: "zones",
        name: "Zones",
        component: () => import("@/modules/Owners/Pages/Zones/ZonesList"),
        meta: {
          breadcrumb: [
            { name: "common.owners", link: OWNERS_INDEX },
            { name: "common.zones", link: ZONES },
            { name: "common.list", link: ZONES },
          ],
          code: MODULE.OWNERS.ZONES,
        },
      },
      {
        path: "zones/show/:id",
        name: "zoneVisualization",
        component: () =>
          import("@/modules/Owners/Pages/Zones/ZoneVisualization"),
        meta: {
          breadcrumb: [
            { name: "common.owners", link: OWNERS_INDEX },
            { name: "common.zones", link: ZONES },
            { name: "common.show", link: ZONES_SHOW },
          ],
          code: MODULE.OWNERS.ZONES,
        },
      },
      {
        path: "zones/create",
        name: "zoneCreation",
        component: () => import("@/modules/Owners/Pages/Zones/ZoneCreation"),
        meta: {
          breadcrumb: [
            { name: "common.owners", link: OWNERS_INDEX },
            { name: "common.zones", link: ZONES },
            { name: "common.show", link: ZONES_SHOW },
          ],
          code: MODULE.OWNERS.ZONES,
        },
      },
      // PRICING
      {
        path: "rates",
        name: "Rateslist",
        component: () => import("@/modules/Owners/Pages/Rates/RatesList"),
        meta: {
          code: MODULE.OWNERS.PRICING,
        },
      },
      {
        path: "rates/types",
        name: "RateFormTypes",
        component: () => import("@/modules/Owners/Pages/Rates/RateFormTypes"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.PRICING,
        },
      },
      {
        path: "rates/:type/form/:rateId?",
        name: "RateForm",
        component: () => import("@/modules/Owners/Pages/Rates/RateFormV2"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.PRICING,
        },
      },
      {
        path: "rates/detail/:id",
        name: "RateDetail",
        component: () =>
          import("@/modules/Owners/Pages/Rates/Detail/RateDetailWrapper.vue"),
        meta: {
          breadcrumb: [{ name: "common.rates", link: RATE }],
          code: MODULE.OWNERS.PRICING,
        },
        children: [
          {
            path: "information",
            name: "RateInformation",
            component: () =>
              import(
                "@/modules/Owners/Pages/Rates/Detail/RateDetailInformation.vue"
              ),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "vigencies",
            name: "RateDetailVigencies",
            component: () =>
              import("@/modules/Owners/Pages/Rates/Detail/RateDetailVigencies"),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "calendar",
            name: "RateCalendar",
            component: () =>
              import("@/modules/Owners/Pages/Rates/Detail/RateDetailCalendar"),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "branch",
            name: "RateDetailBranches",
            component: () =>
              import("@/modules/Owners/Pages/Rates/Detail/RateDetailBranches"),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "price",
            name: "RateDetailPrices",
            component: () =>
              import("@/modules/Owners/Pages/Rates/Detail/RateDetailPrices"),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "category",
            name: "RateCategories",
            component: () =>
              import(
                "@/modules/Owners/Pages/Rates/Detail/RateDetailCategories.vue"
              ),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "vehicle",
            name: "RateVehicles",
            component: () =>
              import(
                "@/modules/Owners/Pages/Rates/Detail/RateDetailVehicles.vue"
              ),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "associations",
            name: "RateAssociations",
            component: () =>
              import(
                "@/modules/Owners/Pages/Rates/Detail/RateDetailAssociations.vue"
              ),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
          {
            path: "calculator",
            name: "RateCalculator",
            component: () =>
              import(
                "@/modules/Owners/Pages/Rates/Detail/RateDetailCalculator.vue"
              ),
            meta: {
              code: MODULE.OWNERS.PRICING,
            },
          },
        ],
      },
      // PROMOTIONS
      {
        path: "promotions",
        name: "PromotionsOwnerList",
        component: () =>
          import("@/modules/Owners/Pages/Promotions/PromotionsList"),
        meta: {
          code: MODULE.OWNERS.PROMOTIONS,
        },
      },
      {
        path: "promotions/form",
        name: "PromotionsFormOwnerList",
        component: () =>
          import("@/modules/Owners/Pages/Promotions/PromotionForm"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.PROMOTIONS,
        },
      },
      {
        path: "promotions/detail/:id",
        name: "PromotionDetailWrapper",
        component: () =>
          import(
            "@/modules/Owners/Pages/Promotions/PromotionDetailWrapper.vue"
          ),
        meta: {
          code: MODULE.OWNERS.PROMOTIONS,
        },
        children: [
          {
            path: "detail",
            name: "PromotionDetail",
            component: () =>
              import("@/modules/Owners/Pages/Promotions/PromotionDetail.vue"),
            meta: {
              code: MODULE.OWNERS.PROMOTIONS,
            },
          },
          {
            path: "activations",
            name: "PromoActivations",
            component: () =>
              import(
                "@/modules/Owners/Pages/Promotions/PromotionActivations.vue"
              ),
            meta: {
              code: MODULE.OWNERS.PROMOTIONS,
            },
          },
        ],
      },
      // CORPORATE-NETWORKS
      {
        path: "corporateNetwork",
        name: "Corporate Networks",
        component: () =>
          import(
            "@/modules/Owners/Pages/CorporateNetworks/CorporateNetworksList"
          ),
        meta: {
          code: MODULE.OWNERS.CORPORATE_NETWORKS,
        },
      },
      {
        path: "corporateNetwork/form",
        name: "Corporate Network Form",
        component: () =>
          import(
            "@/modules/Owners/Pages/CorporateNetworks/CorporateNetworkForm"
          ),
        meta: {
          code: MODULE.OWNERS.CORPORATE_NETWORKS,
        },
      },
      {
        path: "corporateNetwork/detail/:id",
        name: "Corporate Network Details",
        component: () =>
          import(
            "@/modules/Owners/Pages/CorporateNetworks/Detail/CorporateNetworkDetailWrapper.vue"
          ),
        meta: {
          code: MODULE.OWNERS.CORPORATE_NETWORKS,
        },
        children: [
          {
            path: "users",
            name: "Corporate Network Details Users",
            component: () =>
              import(
                "@/modules/Owners/Pages/CorporateNetworks/Detail/CorporateNetworkDetailsUsers.vue"
              ),
            meta: {
              code: MODULE.OWNERS.CORPORATE_NETWORKS,
            },
          },
          {
            path: "vehicles",
            name: "Corporate Network Details Vehicles",
            component: () =>
              import(
                "@/modules/Owners/Pages/CorporateNetworks/Detail/CorporateNetworkDetailsVehicles.vue"
              ),
            meta: {
              code: MODULE.OWNERS.CORPORATE_NETWORKS,
            },
          },
          {
            path: "pricing",
            name: "Corporate Network Details Pricing",
            component: () =>
              import(
                "@/modules/Owners/Pages/CorporateNetworks/Detail/CorporateNetworkDetailsPricing.vue"
              ),
            meta: {
              code: MODULE.OWNERS.CORPORATE_NETWORKS,
            },
          },
          {
            path: "legal",
            name: "Corporate Network Details Legal",
            component: () =>
              import(
                "@/modules/Owners/Pages/CorporateNetworks/Detail/CorporateNetworkDetailsLegal.vue"
              ),
            meta: {
              code: MODULE.OWNERS.CORPORATE_NETWORKS,
            },
          },
          {
            path: "detail",
            name: "Corporate Network Details Detail",
            component: () =>
              import(
                "@/modules/Owners/Pages/CorporateNetworks/Detail/CorporateNetworkDetailsDetail.vue"
              ),
            meta: {
              code: MODULE.OWNERS.CORPORATE_NETWORKS,
            },
          },
        ],
      },
      //SUPPORT PHONE NUMBERS
      {
        path: "supportPhoneNumbers",
        name: "Support phone number",
        component: () =>
          import(
            "@/modules/Owners/Pages/SupportPhoneNumbers/SupportPhoneNumberList"
          ),
        meta: {
          code: MODULE.OWNERS.SUPPORT_PHONES,
        },
      },
      {
        path: "supportPhoneNumbers/form",
        name: "Support phone number form",
        component: () =>
          import(
            "@/modules/Owners/Pages/SupportPhoneNumbers/SupportPhoneNumberForm"
          ),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.SUPPORT_PHONES,
        },
      },
      {
        path: "supportPhoneNumbers/detail/:id",
        name: "Support phone number detail",
        component: () =>
          import(
            "@/modules/Owners/Pages/SupportPhoneNumbers/SupportPhoneNumberDetail"
          ),
        meta: {
          code: MODULE.OWNERS.SUPPORT_PHONES,
        },
      },
      // BILLING
      {
        path: "billing",
        name: "Billing",
        component: () =>
          import("@/modules/Owners/Pages/Billing/BillingAccounting.vue"),
        meta: {
          breadcrumb: [{ name: "common.accounting", link: BILLING }],
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "billing/period/:period",
        name: "OwnersBilling",
        component: () => import("@/modules/Owners/Pages/Billing/OwnersBilling"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "billing/period/:period/:idOwner",
        name: "OwnerBilling",
        component: () =>
          import("@/modules/Owners/Pages/Billing/OwnerBilling.vue"),
        meta: {
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "billing/period/:period/:idOwner/:idVehicle/year/:year",
        name: "VehicleBillingYear",
        component: () =>
          import("@/modules/Owners/Pages/Billing/VehicleBilling-year.vue"),
        meta: {
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "billing/period/:period/:idOwner/:idVehicle/month/:month/:year",
        name: "VehicleBillingMonth",
        component: () =>
          import("@/modules/Owners/Pages/Billing/VehicleBilling-month.vue"),
        meta: {
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "billing/period/:period/:idOwner/:idVehicle/day/:day/:month/:year",
        name: "VehicleBillingDay",
        component: () =>
          import("@/modules/Owners/Pages/Billing/VehicleBilling-day.vue"),
        meta: {
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "billing/accounting",
        name: "Accounting",
        component: () =>
          import("@/modules/Owners/Pages/Billing/BillingAccounting.vue"),
        meta: {
          breadcrumb: [
            { name: "common.accounting", link: BILLING },
            { name: "common.accounting", link: BILLING_ACCOUNTING },
          ],
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "billing/accounting/:year/:month/:idOrder",
        name: "AccountingMonth",
        component: () =>
          import("@/modules/Owners/Pages/Billing/TransactionProcess.vue"),
        meta: {
          code: MODULE.OWNERS.BILLING,
        },
      },
      {
        path: "charges",
        name: "Charges",
        component: () => import("@/modules/Owners/Pages/Billing/Payments"),
        meta: {
          breadcrumb: [],
          code: MODULE.OWNERS.PAYMENTS,
        },
      },
      // reports
      {
        path: "reports",
        name: "Reports type",
        component: () => import("@/modules/Owners/Pages/Reports/ReportsType"),
        meta: {
          code: MODULE.OWNERS.REPORTS,
          breadcrumb: [],
        },
      },
      {
        path: "reports/:reportType/:ownerId",
        name: "Reports",
        component: () => import("@/modules/Owners/Pages/Reports/Reports"),
        meta: {
          code: MODULE.OWNERS.REPORTS,
          breadcrumb: [],
        },
      },
      // agencies
      {
        path: "agency/list",
        name: "Agency List",
        component: () => import("@/modules/Owners/Pages/Agencies/AgencyList"),
        meta: {
          code: MODULE.OWNERS.AGENCIES,
          breadcrumb: [],
        },
      },
      {
        path: "agency/form",
        name: "Agency Form",
        component: () => import("@/modules/Owners/Pages/Agencies/AgencyForm"),
        meta: {
          code: MODULE.OWNERS.AGENCIES,
          breadcrumb: [],
        },
      },
      {
        path: "agency/detail/:agencyId",
        name: "Agency Detail",
        component: () =>
          import("@/modules/Owners/Pages/Agencies/AgencyDetailWrapper"),
        meta: {
          code: MODULE.OWNERS.AGENCIES,
        },
        children: [
          {
            path: "information",
            name: "Agency Detail Information",
            component: () =>
              import("@/modules/Owners/Pages/Agencies/AgencyDetailInformation"),
            meta: {
              code: MODULE.OWNERS.AGENCIES,
            },
          },
          {
            path: "pendingBonuses",
            name: "Agency Detail Pending Bonuses",
            component: () =>
              import(
                "@/modules/Owners/Pages/Agencies/AgencyDetailPendingBonuses"
              ),
            meta: {
              code: MODULE.OWNERS.AGENCIES,
            },
          },
          {
            path: "liquidatedBonuses",
            name: "Agency Detail Liquidated Bonuses",
            component: () =>
              import(
                "@/modules/Owners/Pages/Agencies/AgencyDetailLiquidatedBonuses"
              ),
            meta: {
              code: MODULE.OWNERS.AGENCIES,
            },
          },
          {
            path: "liquidations",
            name: "Agency Detail Liquidations",
            component: () =>
              import(
                "@/modules/Owners/Pages/Agencies/AgencyDetailLiquidations"
              ),
            meta: {
              code: MODULE.OWNERS.AGENCIES,
            },
          },
        ],
      },
      // collection
      {
        path: "collection/list",
        name: "Collection List",
        component: () =>
          import("@/modules/Owners/Pages/Collection/CollectionList"),
        meta: {
          code: MODULE.OWNERS.COLLECTION,
          breadcrumb: [],
        },
      },
    ],
  },
];
